<template>
  <div class="qunti-huaxiang-detail child-detail" style="background-color: #0e264b;">
      <ChildModal :title="$store.state.childModalTitle" :closeProperties="setLvyouyuqingxiangqingShow">

      <div class="content" v-if="yuqingliebiaoData">
      
          <div class="subTitle" >舆情来源详情</div>
          <div class="topbar">
            <div>数据来源</div>
            <div>作者</div>
            <div>相关景区</div>
            <div>发布时间</div>
            <div>OTA游客打分</div>
            <div>原网址</div>
          </div>
          <div class="wrapper">
            <BScroll>
              <ul class="table">
                <li :key="index"
                    v-for="(item, index) in yuqingliebiaoData.data"
                    @click="goSpotRealtime">
                  <div>{{ item.source }}</div>
                  <div>{{ item.author }}</div>
                  <div>{{ item.jingqu }}</div>
                  <div>{{ item.date }}</div>
                  <div>{{ item.pingfen }}</div>
                  <div>{{ item.url }}</div>
                </li>
              </ul>
            </BScroll>
          </div>
          <div class="topbar">
            <div>正文内容</div>
          </div>
          <div class="wrapper">
          <ul class="table text">
                <li :key="index"
                    v-for="(item, index) in yuqingliebiaoData.data"
                    @click="goSpotRealtime">
                  <div>{{ item.content }}</div>
                </li>
              </ul>
    </div>
       <div>
        <div class="subTitle"></div>
        <div class="subTitle">传播河流图</div>
        <ThemeRiver id="heliuchuanbotuChart"
                    :chartData="heliuchuanbotuData"
                    :width = "containerSizeW"
                    :height= "containerSizeH"
                    v-if="heliuchuanbotuData"/>
      </div>
          <div>
        <div class="subTitle"></div>
        <div class="subTitle">传播区域分析</div>
              <SpreadMap
                      width="856px"
                      height="640px"
                      id="chuanboquyuChart"
                      :chartData="chuanboquyuData"
                      v-if="chuanboquyuData"
              />
      </div>
          <div>
        <div class="subTitle"></div>
        <div class="subTitle">传播路径分析</div>
        <TreeRadial id="chuanbolujingfenxiChart"
                    :chartData="chuanbolujingfenxiData"
                    :width = "containerSizeW"
                    :height= "containerSizeH"
                    v-if="chuanbolujingfenxiData"/>
      </div>
       <div>
        <div class="subTitle"></div>
        <div class="subTitle">媒体传播排行榜</div>
        <div class="topbar media">
            <div>序号</div>
            <div>传播力</div>
            <div>标题</div>
            <div>发布时间</div>
            <div>媒体名称</div>
          </div>
          <div class="wrapper">
            <BScroll>
              <ul class="table media">
                <li :key="index"
                    v-for="(item, index) in MediaChuanboRankTableData"
                    @click="goSpotRealtime">
                  <div>{{ item.number }}</div>
                  <div>{{ item.chuanboli }}</div>
                  <div>{{ item.title }}</div>
                  <div>{{ item.date }}</div>
                  <div>{{ item.name }}</div>
                </li>
              </ul>
            </BScroll>
          </div>
      </div>

          <div style="height: 50px"></div>

      </div>


      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import Bar3d from "@/components/Mycharts/Bar3d.vue";
import PageHelper from "@/components/Common/PageHelper.vue";
import BScroll from "@/components/Common/BScroll.vue";
import TreeRadial from "@/components/Echarts/Lvyouyulun/TreeRadial.vue";
import ThemeRiver from "@/components/Echarts/Lvyouyulun/ThemeRiver.vue";
import SpreadMap from "@/components/Echarts/JingquKoubei/SpreadMap.vue";



export default {
  name: "ZhuyaoyuqinglaiyuanDetail",
  components: {
    ChildModal,
    Bar3d,
    PageHelper,
    BScroll,
    TreeRadial,
    ThemeRiver,
    SpreadMap
  },
  props: {},
  data() {
    return {
      zhuyaoyuqinglaiyuanDetailChart: "zhuyaoyuqinglaiyuanDetailChart",
      zhuyaoyuqinglaiyuanData: null,
      yuqingliebiaoData: null,
      MediaChuanboRankTableData: null,
      chuanbolujingfenxiData: null,
      heliuchuanbotuData: null,
      chuanboquyuData: null,

      setLvyouyuqingxiangqingShow: "setLvyouyuqingxiangqingShow",

      pageNumber: 1,
      sizeW: 500,
      sizeH: 500,

      scenicSelected: "黄山",
      scenicListShow: false,
      scenicList: ["黄山","泰山","衡山"],

      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","一年内"],

      sortSelected: "时间",
      sortListShow: false,
      sortList: ["时间","热度"],

      typeSelected: "综合",
      typeListShow: false,
      typeList: ["综合","新闻资讯","论坛","贴吧","博客","微博","微信","OTA","视频","问答"],
    };
  },
  computed: {
    containerSizeW: function() {
      return this.sizeW + "px"

    },containerSizeH: function() {
      return this.sizeH + "px"
    }
  },
  mounted() {
    // 舆情列表数据
    fetch("/data/Lvyouyulun/ShishiYuqingTableData.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          console.log("come here....data : "+ json.data.data)
          this.yuqingliebiaoData = json.data;
        });
    // 主要舆情来源
    fetch("/data/Lvyouyulun/MediaChuanboRankTableData.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.MediaChuanboRankTableData = json.data.data;
        });
      // 媒体传播排行榜
    fetch("/data/Lvyouyulun/Zhuyaoyuqinglaiyuan.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.zhuyaoyuqinglaiyuanData = json.data;
        });
    // 舆情列表数据
    fetch("/data/Lvyouyulun/Chuanbolujingfenxi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.chuanbolujingfenxiData = json;
        });
    // 舆情列表数据
    fetch("/data/Lvyouyulun/Heliuchuanbotu.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.heliuchuanbotuData = json.data;
        });
    // 传播区域分析
    fetch("/data/Lvyouyulun/Chuanboquyufenxi.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.chuanboquyuData = json.data;
        });

  },
  methods: {
    jumpPage(pageinfo) {
      console.log(pageinfo);
    },
    goSpotRealtime() {
    }
  }
};
</script>

<style scoped lang="less">
  .subTitle {
    height: 0.5rem;
    font-size: 0.2rem;
    color: #00cdf9;
    font-weight: bold;
    text-align: center;
  }
    .child-modal .content-box .title{height: auto !important;}
    #zhuyaoyuqinglaiyuanDetailChart{margin: 0 auto;
        }
  .content-box {
    padding: 0.3rem;
    box-sizing: border-box;
    /*width: 12rem;*/
    /*height: 10rem;*/
    position: absolute;
    /*left: 50%;*/
    /*top: 50%;*/
    /*transform: translate(-50%, -50%) scale(0.5);*/
    /*transition: all 0.3s;*/
    /*background: rgba(0, 0, 0, 0.5) url(../../assets/spot_bg.jpg);*/
    background-size: 100% 100%;
    box-shadow: 0 0 1.2rem rgba(0, 0, 0, 0.8);
    .title {
    font-size: 0.18rem;
    color: #00cdf9;
    font-weight: bold;
    float: left;width: 100%;
      position: relative;
    .tab {
      /*width: 3.5rem;*/
      /*height: 0.3rem;*/
      /*margin: 0 auto 0.16rem;*/

      > li {
        width: 1.5rem;
        height: 0.34rem;
        line-height: 0.3rem;
        float: left;
        color: @base-text-color;
        cursor: pointer;
        > div {
          float: left;
        }
        .expand {
          /*width: 1.5rem;*/
          height: 0.3rem;
          position: absolute;
          cursor: pointer;
          > div {
            float: left;
            /*width: 0.3rem;*/
            height: 0.3rem;
            line-height: 0.3rem;
                margin-left: 0.1rem;
          }
          .local {
            width: 0.3rem;
            background: url(../../assets/youkexianxiaxingweifenxi/local.png);
            background-size: 100% 100%;
          }
          .arrow {
            width: 30px;
            height: 0.3rem;
            background: url(../../assets/header_menu/arrow.png);
            background-size: 100% 100%;
          }
          .icon {
            width: 20px;
            height: 20px;
            margin-top: -3px;
          }
          .drop-list {
            z-index: 9999;
            position: absolute;
            left: 0;
            top: 0.3rem;
            width: 100%;
            background: #052148;
            border: 1px solid #00cdff;
            padding: 0.05rem 0;
            box-sizing: border-box;
            li:hover {
              background: #0c3964;
            }
          }
        }
      }
    }
  }
  .search {
    width: 2.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0;
    right: 0.3rem;
    input {
      width: 2.02rem;
      height: 0.26rem;
      background: #0e264b;
      border: 0.02rem solid #07779e;
      outline: none;
      float: left;
      padding-left: 0.1rem;
      color: #fff;
          font-size: 0.16rem;
          padding: 0.05rem;
    }
    .search-btn {
      width: 0.26rem;
      height: 0.26rem;
      float: right;
      background: rgba(0, 0, 0, 0.5) url(../../assets/spot_search_btn.jpg);
      background-size: 100% 100%;
      cursor: pointer;
    }
    input::-webkit-input-placeholder {
      color: #ccc;
    }
  }
    .content {
      overflow: hidden;
      width: 95%;
      margin: 0.5rem auto 0;
      height: 92.5%;
      box-sizing: border-box;
      .topbar {
        width: 100%;
        height: 0.38rem;
        color: @light-blue;
        font-weight: bold;
        position: relative;
        background: url(../../assets/remenluxian/table_topbar_bg.png);
        background-size: 100% 100%;
        border: 1px solid #0f84b9;
        overflow: hidden;
        > div {
          float: left;
          height: 0.36rem;
          line-height: 0.36rem;
          border-left: 1px solid #0f84b9;
        }
        div:nth-child(1) {
          width: 15%;
          border-left: none;
        }
        div:nth-child(2) {
          width: 15%;
        }
        div:nth-child(3) {
          width: 15%;
        }
        div:nth-child(4) {
          width: 20%;
        }
        div:nth-child(5) {
          width: 15%;
        }
        div:nth-child(6) {
          width: 20%;
        }
        &.media{
            
        div:nth-child(1) {
          width: 10%;
          border-left: none;
        }
        div:nth-child(2) {
          width: 10%;
        }
        div:nth-child(3) {
          width: 50%;
        }
        div:nth-child(4) {
          width: 20%;
        }
        div:nth-child(5) {
          width: 10%;
        }
          }
      }
      .topbar::before {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        left: 0.04rem;
        top: 0;
      }
      .topbar::after {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        right: 0.04rem;
        top: 0;
      }
      .wrapper {
        overflow: hidden;
        width: 100%;
        height: calc(100% - 1.2rem);
      }
      .table {
        li {
          height: 0.36rem;
          line-height: 0.36rem;
          background: #07527c;
          border: 1px solid #0f84b9;
          border-bottom: none;
          font-size: 0.14rem;
          > div {
            height: 0.36rem;
            float: left;
          border-left: 1px solid #0f84b9;
          }
          div:nth-child(1) {
            width: 15%;
          border-left: none
          }
          div:nth-child(2) {
            width: 15%;
          }
          div:nth-child(3) {
            width: 15%;
          }
        div:nth-child(4) {
          width: 20%;
        }
        div:nth-child(5) {
          width: 15%;
        }
        div:nth-child(6) {
          width: 20%;
        }
        }
        li:nth-child(1) {
          border-top: none;
        }
        li:nth-of-type(odd) {
          background: rgba(6, 51, 81, 0.84);
        }
        li:last-child {
          border-bottom: 1px solid #0f84b9;
        }
          &.text{
              li{
                  height: auto;
                  line-height: 1.2;
                  div:nth-child(1) {
                      float: none;
            width: 100%;height: auto;
                      text-align: left;
                      padding: 0.05rem;
          }
              }
          }
          
        &.media{
            li{
        div:nth-child(1) {
          width: 10%;
          border-left: none;
        }
        div:nth-child(2) {
          width: 10%;
        }
        div:nth-child(3) {
          width: 50%;
        }
        div:nth-child(4) {
          width: 20%;
        }
        div:nth-child(5) {
          width: 10%;
        }
          }
          }
      }
      .page {
        width: 100%;
        margin: 0 auto;
        background: #1b3e65;
      }
    }
  }
</style>
